import React from "react";
import { motion } from "framer-motion";
import {
  BadgeCheck, Lightbulb, Stethoscope, Map,
  Atom, Truck, Users, ShieldCheck,
} from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, title: "Premium Quality" },
  { icon: Lightbulb, title: "Innovative Products" },
  { icon: Stethoscope, title: "Trusted by Doctors" },
  { icon: Map, title: "Nationwide Presence" },
  { icon: Atom, title: "Scientific Excellence" },
  { icon: Truck, title: "Reliable Supply Chain" },
  { icon: Users, title: "Customer-Centric Approach" },
  { icon: ShieldCheck, title: "Ethical Business Practices" },
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="py-24 sm:py-32 px-6 sm:px-10 lg:px-10 bg-gradient-to-b from-white to-slate-100 relative overflow-hidden">
      <div className="absolute inset-0 grid-pattern opacity-40" />
      <div className="max-w-7xl mx-auto relative">
        <div className="text-center max-w-2xl mx-auto">
          <div className="section-eyebrow" data-testid="why-eyebrow">Why Choose Us</div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900" data-testid="why-heading">
            Eight reasons partners choose <span className="text-gradient">Andrich</span>.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: (i % 4) * 0.06 }}
              className="group relative rounded-2xl bg-white/80 backdrop-blur border border-slate-200 p-6 text-center hover:-translate-y-1.5 hover:shadow-xl hover:border-green-300 transition-[transform,box-shadow,border-color] duration-300"
              data-testid={`why-card-${i}`}
            >
              <div className="mx-auto h-12 w-12 rounded-full bg-gradient-to-br from-blue-900 to-green-600 text-white flex items-center justify-center shadow-md">
                <it.icon size={20} />
              </div>
              <h3 className="mt-5 font-display text-[0.95rem] font-semibold text-slate-900 leading-snug">{it.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
